export default [
  {
    title: 'Brand',
    // icon: 'AwardIcon',
    icon: 'award',
    children: [
      {
        title: 'Overview',
        route: 'brand',
      },
      {
        title: 'Vision',
        route: 'brand-vision',
      },
      {
        title: 'Mission',
        route: 'brand-mission',
      },
      {
        title: 'Values',
        route: 'brand-values',
      },
    ],
  },
]
